// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"63191e26","213":"de9a0af0","798":"9ced6736","938":"6621d81e"}[chunkId] + ".css";
};